import { formatNumberWithK } from '~/helpers'
import i18n from '~/i18n'
import { primary as theme } from '~/styles/themes'

import { formatCompareMetricLabel, formatStylesChart } from '../../helpers'
import { CreateDataset } from '../types'
import { OptionsScale } from './types'

const axisID = 'y-roas'

const settings = {
  label: i18n.t('rm:metrics.roas'),
  formatData: (value: number) => formatNumberWithK({ number: value }),
  color: theme.colors.warning,
  dataKey: 'roas' as keyof ReportHistoryCampaigns,
  order: 40
}

const dataset: CreateDataset = ({ data, isCompare = false }) => ({
  yAxisID: isCompare ? `${axisID}-compare` : axisID,
  type: 'line',
  label: formatCompareMetricLabel({ label: settings.label, isCompare }),
  data: data?.[settings.dataKey] || null,
  order: isCompare ? settings.order - 1 : settings.order,

  ...formatStylesChart({ color: settings.color, isCompare })
})

const optionsScale: OptionsScale = ({
  selectedMetrics,
  showScaleRuler = true,
  drawOnChartArea = true,
  position = 'left',
  isCompare = false
}) => {
  return {
    [isCompare ? `${axisID}-compare` : axisID]: {
      display: showScaleRuler,
      position,
      grid: {
        // If true, draw lines on the chart area inside the axis lines. This is useful
        // when there are multiple axes and you need to control which grid lines are drawn.
        drawOnChartArea
      },
      beginAtZero: true,
      suggestedMin: 0,
      suggestedMax: null,
      ticks: {
        z: 30,
        color: settings.color,
        callback: settings.formatData
      }
    }
  }
}
const viewsPreset = { axisID, dataset, optionsScale, settings }

export default viewsPreset
